<div class="container">
  @switch (errorType()) { @case (MfaErrors.IS_QR_CODE_FAIL) {
  <h3>
    {{ 'setUpTwoFactor.authenticatorApp.failTitle' | translate }}
  </h3>
  <h4>
    {{ 'setUpTwoFactor.authenticatorApp.mfaQrCodeError1' | translate }}
    <br />
    {{ 'setUpTwoFactor.authenticatorApp.mfaQrCodeError2' | translate }}
  </h4>
  <button
    mat-stroked-button
    class="cancel-button"
    type="submit"
    (click)="navigateToOrigin()"
  >
    {{ 'setUpTwoFactor.ok' | translate }}
  </button>
  } @case (MfaErrors.IS_TIMED_OUT) {
  <img
    ngSrc="../../../assets/images/mfa-magnifier.png"
    width="152"
    height="118"
    class="illustration"
  />
  <h3>
    {{ 'twoFactor.mfaTimeoutErrorTitle' | translate }}
  </h3>
  <h4>
    {{ 'twoFactor.mfaTimeoutError1' | translate }}
    <br />
    {{ 'twoFactor.mfaTimeoutError2' | translate }}
  </h4>
  <button
    mat-stroked-button
    class="cancel-button"
    type="submit"
    (click)="navigateToOriginLogin(true)"
  >
    {{ 'twoFactor.mfaTimeoutErrorConfirm' | translate }}
  </button>
  } @case (MfaErrors.IS_EMAIL_MISSING) {
  <button
    mat-icon-button
    class="close-button"
    aria-label="close"
    (click)="navigateToOriginLogin(false)"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div class="alert">
    <mat-icon>error_outline</mat-icon>
  </div>
  <h3>
    {{ 'twoFactor.mfaEmailMissingErrorTitle' | translate }}
  </h3>
  <h4>
    {{ 'twoFactor.mfaEmailMissingError1' | translate }}
    <br />
    {{ 'twoFactor.mfaEmailMissingError2' | translate }}
    <br />
    {{ 'twoFactor.mfaEmailMissingError3' | translate }}
  </h4>
  } @default {
  <h3>
    {{ 'setUpTwoFactor.authenticatorApp.failTitle' | translate }}
  </h3>
  <h4>
    {{ 'login.mfaGeneralError1' | translate }}
    <br />
    {{ 'login.mfaGeneralError2' | translate }}
  </h4>
  <button
    mat-stroked-button
    class="cancel-button"
    type="submit"
    (click)="navigateToOriginLogin(false)"
  >
    {{ 'setUpTwoFactor.ok' | translate }}
  </button>
  } }
</div>
